import { useCallback, useMemo } from 'react';
import { PRODUCT_DISCOVERY_PROJECT, type ProjectType } from '@atlassian/jira-common-constants';
import { CoordinationClient } from '@atlassian/jira-engagement';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import { useDeferEpMessageKey } from '../ep-messages';
import { useJpdModalCanShow } from '../user-property';

export const useCoordinationClient = (projectType?: ProjectType) => {
	const epMessageId = useDeferEpMessageKey(projectType);
	const { checkJpdUserProperties } = useJpdModalCanShow(projectType);

	const { cloudId } = useTenantContext();
	const { data: orgId } = useOrgId();

	const coordinationClient = useMemo(
		() => new CoordinationClient(cloudId, '/gateway/api', false, orgId),
		[cloudId, orgId],
	);

	const start = useCallback(async () => {
		if (!epMessageId) return false;

		// For JPD we need to check a user property that tells if a modal that is
		// not using EP has been dismissed
		if (projectType === PRODUCT_DISCOVERY_PROJECT) {
			const jpdModalWasShown = await checkJpdUserProperties();

			if (!jpdModalWasShown) {
				return false;
			}
		}

		return coordinationClient.start(epMessageId);
	}, [epMessageId, projectType, coordinationClient, checkJpdUserProperties]);

	const stop = useCallback(() => {
		if (!epMessageId) return false;

		return coordinationClient.stop(epMessageId);
	}, [epMessageId, coordinationClient]);

	return {
		start,
		stop,
	};
};
